import { cx } from '@/lib/cx';
import { formatarMoeda } from '@/lib/formato';

/** Valor em reais com algarismos tabulares — alinha em coluna. Recebe a string decimal do contrato. */
export function Dinheiro({
  valor,
  className,
}: {
  valor: string | null | undefined;
  className?: string;
}) {
  const negativo = typeof valor === 'string' && valor.startsWith('-');
  return (
    <span className={cx('tabular whitespace-nowrap', negativo && 'text-perigo', className)}>
      {formatarMoeda(valor)}
    </span>
  );
}
